export default __webpack_public_path__ + "c1373dcd0d4dea7149a627043e99d370.svg";